import React from 'react';
import { motion } from 'framer-motion';
import { Search, SlidersHorizontal, CheckCircle2 } from 'lucide-react';
export function PortalHowItWorks() {
  const steps = [{
    icon: <Search size={24} data-id="element-590" />,
    title: '1. Locate your account',
    description: 'Use your account number from your letter, or sign in to view your details.'
  }, {
    icon: <SlidersHorizontal size={24} data-id="element-591" />,
    title: '2. Choose your plan',
    description: 'Select a payment amount or set up a recurring payment schedule that works for you.'
  }, {
    icon: <CheckCircle2 size={24} data-id="element-592" />,
    title: '3. Submit securely',
    description: 'Enter your payment details over our encrypted connection and receive an instant receipt.'
  }];
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-593">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-594">
        <div className="text-center mb-10" data-id="element-595">
          <h2 className="text-2xl font-bold text-brand-navy" data-id="element-596">How it works</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-597">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="text-center" data-id="element-598">
              <div className="w-12 h-12 bg-brand-gray rounded-full flex items-center justify-center mx-auto mb-4 text-brand-navy" data-id="element-599">
                {step.icon}
              </div>
              <h3 className="font-bold text-brand-dark mb-2" data-id="element-600">{step.title}</h3>
              <p className="text-sm text-brand-muted leading-relaxed max-w-xs mx-auto" data-id="element-601">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}